export default __webpack_public_path__ + "9e58d44f1e145042c5569f3465912242.png";